import BathtubIcon from '../assets/symbols/badkar 1 ny-01.svg';
import HexagonalCoffeeTableIcon from '../assets/symbols/poly 3-01.svg';
import OctagonalCoffeeTableIcon from '../assets/symbols/poly 1-01.svg';
import PentagonalCoffeeTableIcon from '../assets/symbols/poly 2-01.svg';
import { SvgType } from '../types/floorplannerTypes';
import { repairUploadedModelFootprintUnitCorruption } from '../features/floorplan3d/symbols/assets/userModelFootprintSvg';

type LegacySvgRepair = {
  libraryKey: string;
  name: string;
  svgPath: string;
  svgLength: number;
  svgHeight: number;
  matches: Array<RegExp>;
};

const LEGACY_SVG_REPAIRS: LegacySvgRepair[] = [
  {
    libraryKey: 'MANUAL/bathtub',
    name: 'Bathtub',
    svgPath: BathtubIcon,
    svgLength: 1.828,
    svgHeight: 0.8,
    matches: [
      /\bbathtub0?1\b/i,
      /\bbadkar(?:%20|\s)+1(?:%20|\s)+ny-01\b/i,
    ],
  },
  {
    libraryKey: 'MANUAL/Octagonal-coffee-table',
    name: 'Octagonal coffee table',
    svgPath: OctagonalCoffeeTableIcon,
    svgLength: 0.9,
    svgHeight: 0.884,
    matches: [
      /\boctagon\b/i,
      /\bpoly(?:%20|\s)+1-01\b/i,
    ],
  },
  {
    libraryKey: 'MANUAL/Pentagonal-coffee-table',
    name: 'Pentagonal coffee table',
    svgPath: PentagonalCoffeeTableIcon,
    svgLength: 0.946,
    svgHeight: 0.939,
    matches: [
      /\bpentagon\b/i,
      /\bpoly(?:%20|\s)+2-01\b/i,
    ],
  },
  {
    libraryKey: 'MANUAL/Hexagonal-coffee-table',
    name: 'Hexagonal coffee table',
    svgPath: HexagonalCoffeeTableIcon,
    svgLength: 1.039,
    svgHeight: 0.906,
    matches: [
      /\bhexagon\b/i,
      /\bpoly(?:%20|\s)+3-01\b/i,
    ],
  },
];

const isPositiveFiniteNumber = (value: unknown): value is number => (
  typeof value === 'number' && Number.isFinite(value) && value > 0
);

const getLegacySvgRepair = (symbol: SvgType): LegacySvgRepair | undefined => {
  const searchable = [
    symbol.name,
    symbol.svgPath,
    symbol.libraryKey,
  ].filter(Boolean).join(' ');

  return LEGACY_SVG_REPAIRS.find((repair) => (
    symbol.libraryKey === repair.libraryKey ||
    repair.matches.some((pattern) => pattern.test(searchable))
  ));
};

export const repairLoadedSvgSymbol = (symbol: SvgType, defaultSvgPath: string): SvgType => {
  const repair = getLegacySvgRepair(symbol);
  const svgLength = isPositiveFiniteNumber(symbol.svgLength)
    ? symbol.svgLength
    : repair?.svgLength ?? 2;
  const svgHeight = isPositiveFiniteNumber(symbol.svgHeight)
    ? symbol.svgHeight
    : repair?.svgHeight ?? 1;
  const fallbackRatio = svgHeight > 0 ? svgLength / svgHeight : 1;
  const svgRatio = isPositiveFiniteNumber(symbol.svgRatio)
    ? symbol.svgRatio
    : fallbackRatio;

  const repairedSymbol = {
    ...symbol,
    ...(repair
      ? {
          name: symbol.name || repair.name,
          libraryKey: symbol.libraryKey || repair.libraryKey,
          svgPath: repair.svgPath,
        }
      : {
          svgPath: symbol.svgPath || defaultSvgPath,
        }),
    svgLength,
    svgHeight,
    svgRatio,
  };

  return repairUploadedModelFootprintUnitCorruption(repairedSymbol);
};
